import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import login from "./services";
import { verificarEAtivar2FA } from "../2fa/validar-2fa/slices";

interface IRequestGetLogin {
  user: string;
  pass: string;
}

interface IStateLogin {
  user: object;
  status: "" | "success" | "failed" | "loading";
  feedbackError?: any;
}

export const actionPostLogin: any = createAsyncThunk(
  "GET_LOGIN",
  async (params: IRequestGetLogin) => {
    const { data } = await login(params);
    return data;
  },
);

const loginSlice = createSlice({
  name: "GET_LOGIN",
  initialState: <IStateLogin>{
    user: {},
    status: "",
    feedbackError: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actionPostLogin.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(actionPostLogin.fulfilled, (state, action) => {
      if (action.payload.twoFactorRequired) {
        state.status = "success";
        state.user = action.payload;
      } else {
        state.status = "success";
        state.user = action.payload;
        state.feedbackError = "";
      }
    });
    builder.addCase(actionPostLogin.rejected, (state, action) => {
      state.status = "failed";
      state.feedbackError = action.payload as string;
    });

    builder.addCase(verificarEAtivar2FA.fulfilled, (state, action) => {
      state.status = "success";
      state.user = action.payload;
      state.feedbackError = "";
    });

    builder.addCase(verificarEAtivar2FA.rejected, (state, action) => {
      state.status = "failed";
      state.feedbackError = action.payload as string;
    });
  },
});

export default loginSlice.reducer;
